import React from "react";
import { useSearchParams } from "react-router-dom";
import { LayoutGrid, GitFork, Clock } from "lucide-react";

// Three-way lens switch shared across Explore: Browse (doorway/hub) | Map (graph) | Timeline.
// Preserves the active node when moving between Browse and Map.
export function LensToggle({ nodeId }) {
  const [params, setParams] = useSearchParams();
  const view = params.get("view");
  const activeNode = nodeId || params.get("node") || params.get("focus");
  const current = view === "map" ? "map" : view === "timeline" ? "timeline" : "browse";

  const go = (lens) => {
    const next = new URLSearchParams();
    if (lens === "map") {
      next.set("view", "map");
      if (activeNode) next.set("node", activeNode);
    } else if (lens === "timeline") {
      next.set("view", "timeline");
    } else if (activeNode) {
      next.set("node", activeNode);
    }
    setParams(next);
  };

  const items = [
    { key: "browse", label: "Browse", Icon: LayoutGrid },
    { key: "map", label: "Map", Icon: GitFork },
    { key: "timeline", label: "Timeline", Icon: Clock },
  ];

  return (
    <div
      className="inline-flex items-center gap-1 bg-[#f5f4f0] rounded-full p-1 border border-[#14140f]/10"
      data-testid="explore-lens-toggle"
    >
      {items.map(({ key, label, Icon }) => (
        <button
          key={key}
          data-testid={`lens-toggle-${key}`}
          onClick={() => go(key)}
          className={`flex items-center gap-1.5 text-xs font-semibold px-3 py-1.5 rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-[#10a37f] ${
            current === key
              ? "bg-[#ff7360] text-[#14140f]"
              : "text-[#4e6073] hover:text-[#14140f]"
          }`}
        >
          <Icon className="w-3.5 h-3.5" strokeWidth={1.75} />
          {label}
        </button>
      ))}
    </div>
  );
}
